module.exports = __webpack_public_path__ + "static/Produktion-mobile-26d852c14344409e068f70d5a4ea0913.gif";